import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import SlotView from './SlotView';
import CommProfileHeader from '../../../Exhibitor/Profile/CommProfileHeader';
import SlotCreate from './SlotCreate';
import { B2BAuthContext } from '../../../../Context/AuthContex/B2BAuthContext';

function SlotManagement() {
  const [toggle, setToggle] = useState<boolean>(false);
  const {
    state: { b2bUser },
  } = B2BAuthContext();
  return (
    <>
      <CommProfileHeader
        addHeadingTitle={`Add new Slots`}
        listHeadingTitle='Slot List'
        createBtnText='Add Slots'
        toggle={toggle}
        setToggle={setToggle}
        notShowingRightSide
      />

      <div className='profile-right-side px-3 py-3'>
        {toggle ? (
          <SlotCreate
            user_id={b2bUser?.b2b_id as number}
            type='B2B'
            handleClose={() => setToggle(!toggle)}
          />
        ) : (
          <div className='profile-right-info pt-3 ps-2'>
            {false ? (
              <div className='text-center mt-3'>
                <Spinner animation='border' variant='primary' />
              </div>
            ) : (
              <>
                <SlotView user_id={b2bUser?.b2b_id as number} type='B2B' />
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default SlotManagement;
